<template>
  <div class="vb-pratica">
    <services :services="services" />
    <h1 class="vb-heading h2">I dati dei viaggiatori</h1>
    <p class="mb-0">
      Verifica con attenzione i dati personali dei partecipanti al viaggio che
      devono corrispondere a quelli presenti sui documenti che utilizzerai per
      <span v-if="has_flights">i checkin aeroportuali e alberghieri.</span>
      <span v-else> il check-in alberghiero. </span>
    </p>
    <b-row>
      <card-pax
        v-for="(paxs, paxs_index) in passengers"
        :key="`${_uid}:${paxs_index}`"
        :pax="paxs"
        :index="paxs_index + 1"
        :col="'col-xl-6'"
      />
    </b-row>
  </div>
</template>

<script>
import Services from "@alpitour/components/blocks/services.vue";
import CardPax from "@alpitour/components/blocks/card-pax.vue";
export default {
  name: "pratica",
  props: {
    services: Object,
    passengers: Array,
  },
  components: {
    services: Services,
    "card-pax": CardPax,
  },
  computed: {
    has_flights() {
      const { flights = [] } = this.services || {};
      return flights.length > 0;
    },
  },
};
</script>
